export enum EngineTypeEnum {
  EV_PHEV = 'EV_PHEV',
  COMBUSTION = 'COMBUSTION',
}
